import React, { useState } from "react";
import styled from "styled-components/macro";
import { ChevronDownRegular } from "@fluentui/react-icons";

import { FILTERABLE_STATUSES, MONTH_STATUS_DETAILS } from "./constants";
import {
    Checkbox,
    FieldBox,
    PopoverItem,
    PopoverPanel,
    StatusSwatch,
    UnstyledButton,
} from "./index.style";

/**
 * Liste déroulante "État" (multi-sélection) avec le nombre de collaborateurs par statut
 * @param {{ value: string[], counts?: object, onToggle: function }} props
 */
const StatusFilterDropdown = ({ value = [], counts = {}, onToggle }) => {
    const [open, setOpen] = useState(false);

    const label = value.length
        ? value.map((s) => MONTH_STATUS_DETAILS[s].label).join(", ")
        : "Tous";

    return (
        <Wrapper>
            <Trigger
                onClick={() => setOpen((o) => !o)}
                onBlur={() => setOpen(false)}
            >
                <FieldBox as="span" $focused={open}>
                    <Placeholder>État</Placeholder>
                    <Selected $active={value.length > 0}>{label}</Selected>
                    <ChevronDownRegular fontSize={12} color="#616161" />
                </FieldBox>
            </Trigger>
            {open && (
                <PopoverPanel>
                    {FILTERABLE_STATUSES.map((month_status) => (
                        <PopoverItem
                            key={month_status}
                            // mousedown + preventDefault : garde le focus, la liste reste ouverte
                            onMouseDown={(e) => {
                                e.preventDefault();
                                onToggle(month_status);
                            }}
                        >
                            <Checkbox checked={value.includes(month_status)} />
                            <StatusSwatch
                                $color={MONTH_STATUS_DETAILS[month_status].color}
                            />
                            <ItemLabel>
                                {MONTH_STATUS_DETAILS[month_status].label}
                            </ItemLabel>
                            <ItemCount>{counts?.[month_status] ?? 0}</ItemCount>
                        </PopoverItem>
                    ))}
                </PopoverPanel>
            )}
        </Wrapper>
    );
};

export default StatusFilterDropdown;

const Wrapper = styled.div`
    position: relative;
    flex: 0 1 220px;
`;

const Trigger = styled(UnstyledButton)`
    width: 100%;
    text-align: left;
    > span {
        width: 100%;
    }
`;

const Placeholder = styled.span`
    color: #616161;
`;

const Selected = styled.span`
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 600;
    color: ${({ $active }) => ($active ? "#444791" : "#212121")};
`;

const ItemLabel = styled.span`
    flex: 1;
`;

const ItemCount = styled.span`
    font-size: 11px;
    color: #616161;
`;
